  import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
  import Admin from "apis/Admin";
  

  const loginType = localStorage.getItem("loginType");
  export const newsRequest = createAsyncThunk("newsList",async([start,limit])=>{
    const response = await Admin.get(parseInt(loginType) === 1 ? `news/all/${start}/${limit}`: `news/partner/${start}/${limit}`);
    console.log(response,"news response")
    return response.data.data
  });

  export const deleteNews = createAsyncThunk(
    "deleteNews",
    async ([...data]) => {
      await Admin.delete("deleteUserPosts",{data: {posts: [...data]}});
      console.log("delete data")
      return data;
    }
  )

  

  const newsSlice = createSlice({
    name:"news",
    initialState:{newsArray:[],totalList:'',message:"",loading:false},
    reducers:{},
    extraReducers:{
      [newsRequest.fulfilled]:(state,action) => {
        return { ...state, newsArray:action.payload.news, totalList: action.payload.totalNews,message:action.payload.message,loading:false}
      },
      [newsRequest.pending]:(state) => {
         return {...state,loading:true}
      },
      [newsRequest.rejected]:(state,action) => {
        return {
          ...state,
          newsArray:action.payload,
          message:"no data",
          loading:false
        }
      },
      [deleteNews.fulfilled]: (state, action) => {
        console.log(action,"action")
        return {
          ...state,
          newsArray: state.newsArray.filter((data) => data._id !== action.payload[0]),
          loading: false
        };
      },
      [deleteNews.pending]: (state) => {
        return {
          ...state,
          loading: true,
        };
      },
      [deleteNews.rejected]: (state) => {
        return {
          ...state,
          loading: false,
          message: "News Deletion Failed"
        };
      },
    }
  })

  export default newsSlice.reducer;